export default __webpack_public_path__ + "static/media/macbook.e0a8c5d5.png";